// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MarketingBanner-module__wrapper"};